module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Navigation/Exchange-84b59c2c6ba4254b2dca93299f81d11e.svg";